import { styled } from '@withjoy/joykit/theme';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledFlex = styled(Flex)`
  margin-top: ${pxToRem(8)};
  justify-content: space-between;
  align-items: center;
`;
